import React from 'react';
import { useFieldHelper } from 'framework/ui/field';
import {
  ChainIcon,
  StackoverflowIcon,
  GithubIcon,
  WhatsappIcon,
  LinkedinIcon,
  TelegramIcon,
  SkypeIcon,
  ViberIcon,
  DevByIcon,
  RabotaByIcon,
} from 'framework/ui/mui-builder';
import { convertTelegramLink } from 'domain/shared/candidate';
import { ADDITIONAL_CONTACTS_OPTIONS } from 'domain/shared/contact';
import { Box } from '@mui/material';
import { safeExternalHref } from 'framework/utils';

interface ISocialIcon {
  type: string;
  value: string;
}

const socialIconsSvg: Record<string, JSX.Element> = {
  telegram: <TelegramIcon sx={{ width: '21px', height: '21px', marginLeft: '-2px' }} />,
  linkedin: <LinkedinIcon sx={{ width: '16px', height: '17px' }} />,
  whatsapp: <WhatsappIcon sx={{ width: '21px', height: '21px' }} />,
  github: <GithubIcon sx={{ width: '18px', height: '21px' }} />,
  stackoverflow: <StackoverflowIcon sx={{ width: '21px', height: '21px' }} />,
  skype: <SkypeIcon sx={{ width: '21px', height: '21px' }} />,
  viber: <ViberIcon sx={{ width: '22px', height: '22px' }} />,
  'dev.by': <DevByIcon sx={{ width: '25px', height: '25px' }} />,
  'jobs.tut.by': <RabotaByIcon sx={{ width: '25px', height: '25px' }} />,
  defaultSvg: <ChainIcon sx={{ width: '21px', height: '21px' }} />,
};

const SocialIcons = () => {
  const { getValue } = useFieldHelper({ source: 'additionalContacts' });

  const contacts: ISocialIcon[] = (getValue() || []) as any[];

  return (
    <>
      {contacts.map((link: ISocialIcon) => {
        const linkType = link.type.toLowerCase();
        let linkValue = link.value;
        const svg =
          typeof socialIconsSvg[linkType] === 'undefined' ? socialIconsSvg.defaultSvg : socialIconsSvg[linkType];
        if (linkType === ADDITIONAL_CONTACTS_OPTIONS.Telegram.toLowerCase()) {
          linkValue = convertTelegramLink(link.value);
        }

        return (
          <Box
            component="a"
            key={linkValue}
            href={safeExternalHref(linkValue)}
            target="_blank"
            rel="noreferrer"
            title={linkType}
            sx={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              borderRadius: '3px',
              border: '2px solid',
              borderColor: 'primary.main',
              width: '25px',
              height: '25px',
            }}
          >
            {svg}
          </Box>
        );
      })}
    </>
  );
};

export default SocialIcons;
